import type { ApiError } from '@porotutu/react/errors'
import { mutationOptions, type QueryClient, queryOptions } from '@tanstack/react-query'
import { type SliceOptions, staleAfterWrite } from './crud'
import type { Answer, HistoryWindow, Page } from './routes'
import { unwrap } from './unwrap'

const HISTORY_STALE = 5 * 60_000

export function historyQueries<Entry>({
  prefix,
  routes,
}: {
  prefix: readonly string[]
  routes: (params: { id: string }) => {
    history: { get: (options: { query: HistoryWindow }) => Answer<Page<Entry>> }
  }
}) {
  return (id: string, window: HistoryWindow) =>
    queryOptions({
      queryKey: [...prefix, 'history', id, window] as const,
      queryFn: async () => unwrap(await routes({ id }).history.get({ query: window })),
      staleTime: HISTORY_STALE,
    })
}

export function deleteMutationFor<Row extends { id: string }>({
  prefix,
  routes,
  alsoStale = [],
}: SliceOptions & {
  routes: (params: { id: string }) => { delete: () => Answer<Row> }
}) {
  return (queryClient: QueryClient, id: string) =>
    mutationOptions<Row, ApiError, void>({
      mutationKey: [...prefix, 'delete', id],
      mutationFn: async () => unwrap(await routes({ id }).delete()),
      onSettled: staleAfterWrite(queryClient, prefix, alsoStale),
    })
}
